import React from 'react'
import { defineMessage, FormattedMessage } from 'react-intl'

import {
  EligibilityInfo,
  GenerateCustomMetadata,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { generateDbtEligibilityMetadata as generateDbtEligibilityFields } from './registration/dbt/dbtEligibilityMetadata'
import { DbtTeenErrorBanner } from './registration/dbt/DbtTeenErrorBanner'
import { Link } from '../atoms/link/Link'

export const generateDbtEligibilityMetadata: GenerateCustomMetadata = ({ intl, eligibilityInfo }) => {
  return generateDbtEligibilityFields(intl, eligibilityInfo.eligibilityQuestionTitle)
}

const getCustomFields = (_eligibilityInfo: EligibilityInfo) => ({
  DbtTeenErrorBanner: () => <DbtTeenErrorBanner />,
})

export const dbt: GetCustomerCopyFunc = () => {
  return {
    generateEligibilityQuestionTitle: () =>
      defineMessage({
        defaultMessage: 'Are you looking for Dialectical Behavior Therapy (DBT) for yourself?',
        description: 'Question asking if the user is registering for DBT services for themselves',
      }),
    generateEmployeeEligibilityError: () => null,
    eligibilityMetadata: {
      generateMetadata: generateDbtEligibilityMetadata,
      getCustomFields,
    },
    // TODO: Remove this restriction when we enable DBT registration for teen dependents
    userMinAgeRequirement: 18,
    customUnderageErrorWidget: 'dbtUnderageErrorBanner',
    disableSubmitOnDependentSelection: true,
    showCountrySelector: true,
    sessionHistoryDescriptionText: ({ goToCareNavigatorPage }) => (
      <FormattedMessage
        defaultMessage='Reach out to our <link>Care Navigator</link> team if you need additional support with session history.'
        description='Text to inform DBT members to contact care navigator for support with session history.'
        values={{
          link: (text: string) => <Link onPress={() => goToCareNavigatorPage()} text={text} underline={true} />,
        }}
      />
    ),
  }
}
